import { removeToken, getToken, getRefreshToken } from './tokenStorage';
import { pythonApiClient } from '../services/python-api/pythonApiClient';
import useUserStore from '../store/userStore';
import axios from 'axios';

export const authAdapter = {
  isLegacyAuth: () => {
    const token = getToken();
    const refreshToken = getRefreshToken();
    return token && !refreshToken;
  },

  forceLegacyLogout: () => {
    if (authAdapter.isLegacyAuth()) {
      authAdapter.clearAllAuthData();
      return true;
    }
    return false;
  },

  logout: async () => {
    const refreshToken = getRefreshToken();
    
    try {
      if (refreshToken) {
        await pythonApiClient.post('/auth/logout/', { refreshToken: refreshToken });
      } 
    } catch (error) {
      console.warn('Logout API call failed, proceeding with local cleanup:', error);
    }
    
    authAdapter.clearAllAuthData();
  },

  clearAllAuthData: () => {
    removeToken();
    localStorage.removeItem('user_id');
    localStorage.removeItem('is_admin');
    delete axios.defaults.headers.common['Authorization'];
    
    useUserStore.setState({
      user: null,
      token: null,
      isAuthenticated: false,
    });
  },

  initializeAuthCheck: () => {
    const wasLegacyUser = authAdapter.forceLegacyLogout();
    
    if (wasLegacyUser) {
      window.location.href = '/auth/login';
      return false;
    }
    
    return true;
  }
};